export const QUERY_DELAY = 200;
export const QUERY_DELAY_EXTENDED = 1000;
export const QUERY_DEBOUNCE_OPTS = { maxWait: 1000 };

export const WATCHLIST_ID = 'watchlistId';
export const WORKING_LIST_ID = 'workingList';
export const SCREENER_ID = 'screenerId';
export const INDEX_ID = 'indexId';

export const themeExposureFilterKey = 'theme_exposure';
export const countryExposureFilterKey = 'country_exposure';
